import {DiReact} from "react-icons/di";
import {FaNodeJs} from "react-icons/fa";
import {SiExpress,SiMongodb} from "react-icons/si";
import { SiFiverr } from "react-icons/si";
import { AiFillGithub,AiFillLinkedin,AiFillYoutube } from "react-icons/ai";
import { CgFigma } from "react-icons/cg";
import { TbBrandReactNative } from "react-icons/tb";
import { SiAdobexd } from "react-icons/si";

export const menu = [
    {name:"About"},
    {name:"Services"},
    {name:"Skill"},
    {name:"Projects"},
    {name:"Testimonial"},
    {name:"Contact"},
]



export const projects = [
    { 
      id:1,
      title: 'SeriesFlix Index',
      image: 'https://i.postimg.cc/jd32JjFb/Untitled312.png',
      category:"Channels",
      data:{
         description: `
The Telegram SeriesFlix Index channel is a hub for entertainment enthusiasts seeking access to a wide array of television series. This channel provides subscribers with an organized index of various TV shows, From popular favorites to hidden gems, SeriesFlix Index offers a curated collection of series across different genres, With regular updates and a user-friendly interface, it's a go-to destination for those looking to stay informed about the latest and greatest in the world of television.`,
         demoLink: "https://t.me/seriesflix_mania",
      },
      stack:[
        {
          name:"OriginalSeries",
          icon: <SiAdobexd/>,
          iconColor:"skyblue",
        },
        {
          name:"NewSeries",
          icon: <FaNodeJs/>,
          iconColor:"green",
        },
        {
          name:"WatchFree",
          icon: <SiExpress/>,
        },
        {
          name:"SeriesAddict",
          icon: <SiMongodb/>,
          iconColor:"limegreen",
        },
      ]
    },
    {
      id:2,
      title: 'AniFlix',
      image: 'https://i.postimg.cc/25WsQVNy/image-2024-05-31-14-03-25.png',
      category:"Web",
      data:{
        description:`Welcome to AniFlix your best anime site ever! Explore aniflix-me.vercel.app and dive into the world of anime. Enjoy your favorite anime with English subs or dubs, and here's the kicker - you can download individual episodes hassle-free, no sign-up required!`,
        demoLink: "https://aniflix-me.vercel.app/",
      },
      stack:[
        {
          name:"AniFlix",
          icon: <DiReact/>,
          iconColor:"skyblue",
        },
        {
          name:"WatchAnimes",
          icon: <FaNodeJs/>,
          iconColor:"green",
        },
        {
          name:"Dub/Sub",
          icon: <SiExpress/>,
        },
        {
          name:"AdFree",
          icon: <SiMongodb/>,
          iconColor:"limegreen",
        },
      ]
    },
    {
      id:3,
      title: 'Kaido',
      image: 'https://s3-alpha.figma.com/hub/file/5101537097/c4a1ed2c-4ab9-43fb-a248-d7ac6b0c3161-cover.png',
      category:"Web",
      data:{
        description: `Unlock the future of robotics with our Robotic Engineering Web Application
        project. Seamlessly integrating cutting-edge technology, data analytics, 
        and collaborative tools, our platform empowers engineers to design, simulate, 
        and optimize robotic systems. Experience innovation at its peak as we redefine the 
        boundaries of robotic engineering.`,
        demoLink: "https://google.com/",
      },
      stack:[
        {
          name:"ReactJs",
          icon: <DiReact/>,
          iconColor:"skyblue",
        },
        {
          name:"NodeJs",
          icon: <FaNodeJs/>,
          iconColor:"green",
        },
        {
          name:"ExpressJs",
          icon: <SiExpress/>,
        },
        {
          name:"MongoDB",
          icon: <SiMongodb/>,
          iconColor:"limegreen",
        },
        {
          name:"MongoDBT",
          icon: <SiMongodb/>,
        },
        {
          name:"MongoDBT",
          icon: <SiMongodb/>,
        },
        {
          name:"MongoDBT",
          icon: <SiMongodb/>,
        },
      ]
    },
    {
      id:4,
      title: '𝐋ᴜᴄʏ',
      image: 'https://i.postimg.cc/YqC70ssG/lucyx.jpg',
      category:"Bots",
      data:{
        description: `A Auto filter Movies Bot is an automated tool on the Telegram messaging platform that allows users to search for, request, and download or stream movies directly within the app. These bots typically offer a user-friendly interface where users can enter movie titles or browse categories to find films. Features often include high-quality movie links, genre filters, The convenience and ease of access make Telegram Movies Bots popular among movie enthusiasts looking for quick and free movie options.`,
        demoLink: "https://telegram.me/Lucy_Filter_bot",
      },
      stack:[
        {
          name:"AutoFilter",
          icon: <TbBrandReactNative/>,
          iconColor:"skyblue",
        },
        {
          name:"MoviesBot",
          icon: <FaNodeJs/>,
          iconColor:"green",
        },
        {
          name:"AIFeatures",
          icon: <SiExpress/>,
        },
        {
          name:"FreeMovies",
          icon: <SiMongodb/>,
          iconColor:"limegreen",
        },
      ]
    },
    {
      id:5,
      title: 'Anime Cruise',
      image: 'https://i.postimg.cc/gcf4G896/ac-logo.jpg',
      category:"Channels",
      data:{
        description: `"Anime Cruise" is a vibrant Telegram channel dedicated to all things anime. Offering a voyage into the diverse world of Japanese animation, it serves as a hub for fans to explore, Whether you're a seasoned otaku or just dipping your toes into the anime ocean, this channel promises an exciting journey through the colorful and dynamic realm of Japanese animation. Join the crew and set sail on an anime adventure!`,
        demoLink: "https://telegram.me/Anime_Cruise_Netflix",
      },
      stack:[
        {
          name:"AnimeChannel",
          icon: <CgFigma/>,
          iconColor:"orangered",
        },
        {
          name:"AnimeSeries",
          icon: <FaNodeJs/>,
          iconColor:"green",
        },
        {
          name:"BestAnime",
          icon: <SiExpress/>,
        },
        {
          name:"WatchAnime",
          icon: <SiMongodb/>,
          iconColor:"limegreen",
        },
      ]
    },
    {
      id:6,
      title: 'File Store',
      image: 'https://i.postimg.cc/9f3sd8JB/partners.jpg',
      category:"Bots",
      data:{
        description: `telegram Bot to store Posts and Documents and it can Access by Special Links. Custom Auto Delete Features with 2, 3 & 4 Force Subs Channel Support And Many More Features. Check Branch To Know More About Force Subs Channel & token verification too`,
        demoLink: "https://github.com/codeflix-bots/filestore",
      },
      stack:[
        {
          name:"FileStore",
          icon: <TbBrandReactNative/>,
          iconColor:"skyblue",
        },
        {
          name:"AutoDelete",
          icon: <FaNodeJs/>,
          iconColor:"green",
        },
        {
          name:"MultiFsub",
          icon: <SiExpress/>,
        },
        {
          name:"3Fsub",
          icon: <SiMongodb/>,
          iconColor:"limegreen",
        },
      ]
    },
  ]
  


export const experience = [
    {
        title:"Channels",
        data:[
            {
                skill:"Figma",
                level:"Experienced",
            },
            {
                skill:"Sketch",
                level:"Intermediate",
            },
            {
                skill:"XD",
                level:"Intermediate",
            },
        ]
    },
    {
        title:"Frontend Development",
        data:[
            {
                skill:"HTML",
                level:"Experienced",
            },
            {
                skill:"CSS",
                level:"Experienced",
            },
            {
                skill:"JavaScript",
                level:"Experienced",
            },
            {
                skill:"Tailwind",
                level:"Intermediate",
            },
            {
                skill:"Bootstrap",
                level:"Experienced",
            },
            {
                skill:"React",
                level:"Experienced",
            },
            {
                skill:"React Native",
                level:"Experienced",
            },
        ]
    },
    {
        title:"Backend Development",
        data:[
            {
                skill:"Node JS",
                level:"Experienced",
            },
            {
                skill:"MangoDB",
                level:"Intermediate",
            },
            {
                skill:"PHP",
                level:"Experienced",
            },
            {
                skill:"Python",
                level:"Intermediate",
            },
            {
                skill:"MySQL",
                level:"Experienced",
            },
        ]
    },
]


export const socialHandles = [
  {
    name:"Fiverr",
    icon:<SiFiverr/>,
    link:"",
  },
  {
    name:"Github",
    icon:<AiFillGithub/>,
    link:"github.com/codeflix-bots",
  },
  {
    name:"LinkedIn",
    icon:<AiFillLinkedin/>,
    link:"",
  },
  {
    name:"Youtube",
    icon:<AiFillYoutube/>,
    link:"www.youtube.com/@codeflixbots",
  },
];
